import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from 'react';
import {
  MDBIcon,
  MDBBtn,
  MDBModal, MDBModalBody, MDBModalHeader, MDBModalDialog, MDBModalContent
} from 'mdb-react-ui-kit';


function MultiImageCarousel() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    { src: "/gallery/Hector_spi.jpg", caption: "Hector à fond sous spi et sous le soleil ! Les entraînements avec le centre de Concarneau ont commencé. On apprend énormément : réglages, manoeuvres, départs...", title: "23 Février 2025" },
    { src: "/gallery/speed_test_pres.png", caption: "Speed test au près. L'avantage d'avoir deux bateaux identiques, c'est qu'on peut vraiment comparer nos réglages, et s'aider mutuellement pour trouver toutes les astuces pour aller plus vite !", title: "23 Février 2025" },
    { src: "/gallery/redo_gennak_haut.png", caption: "Redo sous gennaker par un beau soleil Concarnois. Les navigations en solo s'enchainent. On commence tout doucement à prendre confiance dans les manoeuvres !", title: "15 Février 2025" },
    { src: "/gallery/plouf_redo.jpg", caption: "Mise à l'eau de Redo, le n°1063, notre second bateau. Après une grosse journée de préparation dans le froid de Port La Forêt, notre équipe est désormais complète : deux skippers et deux bateaux ! C'est fou !", title: "11 Janvier 2025" },
    { src: "/gallery/drone_hector_novembre.jpg", caption: "Retour à Concarneau après un tour des Glénans et une nuit en mer. On s'essaie au drone, et ce n'est pas facile ! ", title: "24 Novembre 2024" },
    { src: "/gallery/convoyage.jpg", caption: "Dans la foulée de la mise à l'eau d'Hector, nous partons en convoyage pour l'amener à son nouveau port d'attache : Concarneau. Une petite trentaine d'heures de navigation où nous avons pu appréhender le potentiel du bateau, et profiter d'un joli levé de soleil près de Belle-Ile.", title: "11 Novembre 2024" },
    { src: "/gallery/plouf_hector.jpg", caption: "Mise à l'eau d'Hector, le n°1039, notre premier bateau. \n Beaucoup d'excitation à l'idée de devenir propriétaire d'un tel bolide de course.", title: "9 Novembre 2024" },
  ];

  const openModal = (index) => {
    setActiveIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div style={{ textAlign: "center", backgroundColor: "rgba(48, 62, 96, 1)", paddingTop: "20px" }}>
      <div style={{ width: '90%', marginLeft: "5%", height: '2px', backgroundColor: '#F2A541' }}></div>
      <h2 style={{ marginBottom: "10px", marginTop: "10px", color: "#F2A541", fontFamily: "Consolas, monospace" }}>Images</h2>

      <Slider {...settings} style={{ marginTop: "10px", 
                                      marginLeft: '3%', 
                                      width: '94%', 
                                      height: '300px' }}>
        {images.map((image, index) => (
          <div key={index} style={{ display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center", 
                                    height: "280px", 
                                    position: "relative",
                                    cursor: "pointer" }}
            onClick={() => openModal(index)}>
            <div style={{ display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center", 
                    height: "100%", 
                    width: "100%" }}>
              <img src={image.src} alt={`Image ${index}`} style={{ maxHeight: "280px", 
                                                                  maxWidth: "90%", 
                                                                  border: "3px solid #F2A541", 
                                                                  borderRadius: '10px', 
                                                                  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)", 
                                                                  objectFit: "contain",
                                                                  height: "auto"}} />
            </div>
          </div>
        ))}
      </Slider>

      {/* MODALE */}
      <MDBModal open={modalOpen} onClose={closeModal} tabIndex="-1">
        <MDBModalDialog centered className="modal-responsive" style={{ maxWidth: "70vw", maxHeight: "80vh" }}>
          <MDBModalContent>
            <MDBModalHeader>
              <h3 style={{ fontFamily: "Consolas, monospace", color: "rgba(48, 62, 96, 1)", fontWeight: "bold" }}>
                {images[activeIndex].title}
              </h3>
              <MDBBtn className="btn-close" color="none" onClick={closeModal}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="text-center" style={{ position: "relative" }}>
              {/* Flèche de navigation gauche */}
              <MDBBtn onClick={prevImage} style={arrowStyle("left")}><MDBIcon fas icon="angle-left" /></MDBBtn>

              {/* Image affichée */}
              <img src={images[activeIndex].src} alt="Image en grand"
                style={{ maxWidth: "65vw", maxHeight: "70vh", borderRadius: "10px", border: "4px solid #F2A541", boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)" }} />

              {/* Flèche de navigation droite */}
              <MDBBtn onClick={nextImage} style={arrowStyle("right")}><MDBIcon fas icon="angle-right" /></MDBBtn>

              {/* Légende */}
              <p style={{ marginTop: "10px", fontSize: "16px", color: "#303E60", fontFamily: "Consolas, monospace" }}>
                {images[activeIndex].caption}
              </p>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
}

// Fonction pour styler les flèches
const arrowStyle = (position) => ({
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  [position]: "10px",
  fontSize: "30px",
  backgroundColor: "transparent",
  color: "rgba(48, 62, 96, 1)",
  borderRadius: "50%",
  width: "10px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  opacity: 0.6,
  transition: "opacity 0.3s",
  border: "none",
  outline: "none",
  boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.0)",
  zIndex: 10
});

export default MultiImageCarousel;
